const translations = {
  "en": {
    "Add Assets": "Add Assets",
    "Back": "Back",
    "Cancel": "Cancel",
    "Crypto": "Crypto",
    "Search Stock Themes / Crypto Themes / Stocks / Crypto / News": "Search Stock Themes / Crypto Themes / Stocks / Crypto / News",
    "Search Themes / Stocks / Crypto": "Search Themes / Stocks / Crypto",
    "Selected": "Selected",
    "Stocks": "Stocks"
  },
  "zh-tw": {
    "Add Assets": "新增資產",
    "Back": "返回",
    "Cancel": "取消",
    "Crypto": "加密貨幣",
    "Search Stock Themes / Crypto Themes / Stocks / Crypto / News": "搜尋股票主題 / 加密貨幣主題 / 股票 / 加密貨幣 / 新聞",
    "Search Themes / Stocks / Crypto": "搜尋主題 / 股票 / 加密貨幣",
    "Selected": "已選擇",
    "Stocks": "股票"
  }
};

export default translations;
